import http from 'plugins/axios';

export default {
    getTransactionList(data) {
        return http.get({
            url: '/admin/etp/transactionList',
            data
        });
    },
    getTransactionNumberTrend(data) {
        return http.get({
            url: '/admin/etp/transactionNumberTrend',
            data
        });
    },
    getTransactionTurnoverTrend(data) {
        return http.get({
            url: '/admin/etp/transactionTurnoverTrend',
            data
        });
    },
};
